/**
 * Your repertoires: /tools/repertoires (docs/REPERTOIRES.md).
 *
 * What the user forgets of their repertoire (the review the server reads) and a round of asking those positions
 * again; the board is a session of its own (`boards.repertoires`).
 */
export const repertoiresSlice = {
    // loading | signedOut | list | question | checking | answered | roundOver
    status: "loading",
    tab: "forget",        // forget | manage
    review: null,         // RepertoireReview once read
    round: [],            // the positions of this round, in order
    index: 0,
    answer: null,         // what the last answer was, once given
    results: [],          // one per position answered this round: right or not
    error: null,
};
